import React, { useState, useContext } from "react";
import { useQueries } from "@tanstack/react-query";
import Layout from "components/Layouts/Layout";
import NavigationLeft from "components/NavigationLeft/NavigationLeft";
import NavigationRight from "components/NavigationRight/NavigationRight";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import "./findTutor.scss";
import { AuthContext } from "context/AuthContext";
import Modal from "react-bootstrap/Modal";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";

import { Dropdown } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import toast from "react-hot-toast";
import Frame from "assets/imgs/icons/Frame.svg";
import Search from "assets/imgs/icons/search.svg";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import { getStudents } from "service/user/parent/progress-reports/get-students";
import getCourseList from "service/courses/course-list";
import tutorsForSession from "service/user/parent/sessions/tutors-for-session";
import getTutorFreeSlots from "service/user/parent/sessions/get-tutor-free-slots";
import bookDemoSession from "service/user/parent/sessions/book-demo-session";
import bookSessions from "service/user/parent/sessions/book-sessions";
import BookTrialSessionTable from "components/BookTrialSessionTable/BookTrialSessionTable";
import getSessionStatus from "service/user/parent/sessions/get-session-status";
import getTimezones from "service/shared/timezones";
import getTimeZones from "service/user/shared/get-timezones";
import { useEffect } from "react";
import FindTutorStepGuide from "components/FindTutorStepGuide/FindTutorStepGuide";
import { useRef } from "react";
import BlankAvatar from "assets/imgs/icons/BlankAvatar.svg";
import downloadImage from "service/shared/image-download";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function FindTutor() {
  const { authState } = useContext(AuthContext);
  const target1 = useRef(null);
  const target2 = useRef(null);
  const target3 = useRef(null);
  const [data, setData] = useState({
    students: { options: [], selected: {} },
    courses: {
      options: [],
      selected: {},
    },
    timeZone: {
      options: [],
      selected: [],
    },
  });
  const [date, setDate] = useState(() => {
    let current_datetime = new Date();
    return (
      current_datetime.getDate() +
      "-" +
      MONTHS[current_datetime.getMonth()] +
      "-" +
      current_datetime.getFullYear()
    );
  });
  const [selectedTutor, setSelectedTutor] = useState("");
  const [courseTutors, setCourseTutors] = useState([]);
  const [selSessions, setSelSessions] = useState([]);
  const [freeSlots, setFreeSlots] = useState([]);
  const [tutorListEmpty, setTutorListEmpty] = useState(false);
  const [sessionBookedMessage, setSessionBookedMessage] = useState("");
  const [weekCount, setWeekCount] = useState(() => {
    let now = new Date();
    const onejan = new Date(now.getFullYear(), 0, 1);
    const week = Math.ceil(
      ((now.getTime() - onejan.getTime()) / 86400000 + onejan.getDay() + 1) / 7
    );
    return week;
  });
  const [sessionStatus, setSessionStatus] = useState({});
  const [newParent, setNewParent] = useState(false);
  const [stepGuide, setStepGuide] = useState(0);
  const [showToolTipStudent, setShowToolTipStudent] = useState(false);
  const [showToolTipCourse, setShowToolTipCourse] = useState(false);
  const [showToolTipConfirm, setShowTooltipConfirm] = useState(false);

  const [bookTrialSessionModal, setBookTrialSessionModal] = useState(false);
  const [sessionBookedModal, setSessionBookedModal] = useState(false);
  const [trialEndedModal, setTrialEndedModal] = useState(false);
  const [confirmSessionModal, setConfirmSessionModal] = useState(false);

  const [fetchTeachers, setFetchTeachers] = useState(false);
  const [fetchFreeSlots, setFetchFreeSlots] = useState(false);
  const [fetchSessionStatus, setFetchSessionStatus] = useState(false);
  const [bookSession, setBookSession] = useState({
    demo: false,
    paid: false,
  });

  const queries = useQueries({
    queries: [
      {
        queryKey: ["liststudents"],
        queryFn: () => getStudents(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d = []) => {
          // console.log(d);
          setData((prev) => {
            return {
              ...prev,
              students: {
                ...prev.students,
                options: d.map(
                  ({ studentName, studentLoginName, studentCifNumber }) => {
                    return {
                      text: `${studentLoginName} (${studentName})`,
                      value: studentCifNumber,
                    };
                  }
                ),
              },
            };
          });
        },
      },
      {
        queryKey: ["getCourses"],
        queryFn: () => getCourseList(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d = []) => {
          // console.log(d);
          let a = [];
          Object.keys(d).forEach(function (key, index) {
            a = [
              ...a,
              ...d[key]?.map((c) => {
                return { text: c.courseName, value: c.courseId };
              }),
            ];
          });
          setData((prev) => {
            return {
              ...prev,
              courses: {
                ...prev,
                options: a,
              },
            };
          });
        },
      },
      {
        queryKey: ["getTimeZones"],
        queryFn: () => getTimeZones(),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d = []) => {
          // console.log(d);
          // console.log(d);
          setData((prev) => {
            return {
              ...prev,
              timeZone: {
                ...prev.timeZone,
                options: d.map((t, i) => {
                  return {
                    label: t.timeZoneName,
                    value: t.timeZoneId,
                  };
                }),
              },
            };
          });
        },
      },
      {
        queryKey: ["getTutorsForSession"],
        queryFn: () => {
          return tutorsForSession(
            authState?.userInfo?.cifNumber,
            data.courses.selected?.value
          );
        },
        enabled: fetchTeachers,
        onSuccess: (d = []) => {
          if (d.length < 1) {
            setTutorListEmpty(true);
          }
          // console.log(d);
          setCourseTutors(d);
          loadImage(d);
        },
        onSettled: () => setFetchTeachers(false),
      },
      {
        queryKey: ["getTutorFreeSlots"],
        queryFn: () => {
          return getTutorFreeSlots(
            authState?.userInfo?.cifNumber,
            selectedTutor?.teacherId,
            weekCount,
            data.timeZone.selected?.value ? data.timeZone.selected?.value : null
          );
        },
        enabled: fetchFreeSlots,
        onSuccess: (d = []) => {
          console.log(d);
          setFreeSlots(d);
        },
        onSettled: () => setFetchFreeSlots(false),
      },
      {
        queryKey: ["getSessionStatus"],
        queryFn: () => {
          let obj = {
            courseId: data.courses.selected?.value,
            studentId: data.students.selected?.value,
            teacherId: selectedTutor.teacherId,
          };
          console.log(obj);
          return getSessionStatus(authState?.userInfo?.cifNumber, obj);
        },
        enabled: fetchSessionStatus,
        onSuccess: (d = []) => {
          console.log(d);
          setSessionStatus(d);
          if (stepGuide != 6) {
            setTrialEndedModal(true);
          }
        },
        onSettled: () => setFetchSessionStatus(false),
      },
      {
        queryKey: ["bookDemoSession-findTutor"],
        queryFn: () => {
          let obj = {
            courseId: data.courses.selected?.value,
            studentId: data.students.selected?.value,
            teacherId: selectedTutor.teacherId,
            slotId: selSessions[0].slotId,
            status: 1,
            courseForSalaryId: data.courses.selected?.value,
            startDate: selSessions[0].date,
            // endDate: selSessions[0].date,
          };
          // console.log(obj);
          return bookDemoSession(authState?.userInfo?.cifNumber, obj);
        },
        enabled: bookSession.demo,
        onSuccess: (d = []) => {
          // console.log(d);
          setSessionBookedMessage(d.message);
          setSessionBookedModal(true);
        },
        onError: () => toast.error("An error occurred!"),

        onSettled: () => handleDemoBookSession,
      },
      {
        queryKey: ["bookSessions-findTutor"],
        queryFn: () => {
          let payload = selSessions?.map((ses, i) => {
            return {
              courseId: data.courses.selected?.value,
              studentId: data.students.selected?.value,
              teacherId: selectedTutor.teacherId,
              slotId: ses.slotId,
              status: 1,
              courseForSalaryId: data.courses.selected?.value,
              startDate: ses.date,
              // endDate: ses.date,
            };
          });
          // console.log(payload);
          return bookSessions(authState?.userInfo?.cifNumber, payload);
        },
        enabled: bookSession.paid,
        onError: () => toast.error("An error occurred!"),
        onSuccess: (d = []) => {
          // console.log(d);
          toast.success(
            "The request has been submitted successfully to your CSM."
          );
          setConfirmSessionModal(false);
        },

        onSettled: () => handleBookSession,
      },
    ],
  });

  const profileImage = (name) => {
    return `https://ui-avatars.com/api/?name=${name}&background=0D8ABC&color=fff`;
  };

  const handleSubmit = () => {
    setShowTooltipConfirm(false);
    if (!sessionStatus?.returnFlag) {
      setBookSession((prev) => {
        return { ...prev, demo: true };
      });
    } else {
      setConfirmSessionModal(true);
    }
  };

  const handleDemoBookSession = () => {
    setBookSession((prev) => {
      return {
        ...prev,
        demo: false,
      };
    });
    setSelSessions([]);
  };
  const handleBookSession = () => {
    setBookSession((prev) => {
      return {
        ...prev,
        paid: false,
      };
    });
    setConfirmSessionModal(false);
    setSelectedTutor("");
    setSelSessions([]);
  };

  function truncateString(str, num = 150) {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  }

  const loadImage = async (users) => {
    console.log("Hi");
    if (users.length > 0) {
      let temp = [...users];
      await Promise.all(
        temp.map(async (user, i) => {
          const res = await downloadImage(user?.teacherId);

          const reader = new FileReader();
          reader.readAsDataURL(res);
          reader.onload = () => {
            temp[i].image = reader.result === "data:" ? null : reader.result;
          };

          // };
        })
      );
      console.log(temp);
      setCourseTutors(temp);
    }
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    if (id == 0) {
      // setNewParent(true);
      setStepGuide(1);
      // console.log("New");
    }
  }, []);

  useEffect(() => {
    if (stepGuide == 3) setShowToolTipStudent(true);
    else if (stepGuide == 4) {
      setShowToolTipCourse(true);
      setShowToolTipStudent(false);
    } else if (stepGuide == 5) setShowToolTipCourse(false);
    else if (stepGuide == 7) setShowTooltipConfirm(true);
  }, [stepGuide]);
  return (
    <Layout searchVisible={true}>
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="container-fluid container-xl">
          {/* title section end */}
          <div className="row py-3 mt-4">
            <div className=" my-auto find-tutor__label-1 col-lg-2 col-md-4 col-sm-12">
              Find a Tutor For
            </div>
            <div className="col-lg-3 col-md-5 col-sm-12" ref={target1}>
              <Dropdown
                placeholder="Select Student"
                fluid
                search
                selection
                value={data.students.selected.value}
                options={data.students.options}
                loading={queries[0].isFetching}
                key={data.students.selected}
                onChange={(e) => {
                  const id = data.students.options.filter((student, i) => {
                    if (student.text === e.target.innerText) {
                      return student;
                    }
                  });
                  setData((prev) => {
                    return {
                      ...prev,
                      students: {
                        ...prev.students,
                        selected: {
                          text: id[0]?.text,
                          value: id[0]?.value,
                        },
                      },
                    };
                  });
                  if (data.courses.selected?.value) {
                    setFetchTeachers(true);
                  }
                  if (stepGuide == 3) {
                    setStepGuide((prev) => prev + 1);
                  }
                }}
              />
              <Overlay
                target={target1.current}
                show={showToolTipStudent}
                placement="right"
              >
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    Select Student
                  </Tooltip>
                )}
              </Overlay>
            </div>
          </div>
          <div className="row py-3">
            <div className=" my-auto find-tutor__label-2 col-lg-2 col-md-4 col-sm-12">
              Select Course
            </div>
            <div className="col-lg-3 col-md-5 col-sm-12" ref={target2}>
              <Dropdown
                placeholder="Course"
                fluid
                search
                selection
                value={data.courses.selected?.value}
                options={data.courses.options}
                loading={queries[1].isFetching}
                // key={data.courses.selected}
                onChange={(e) => {
                  const id = data.courses.options.filter((c, i) => {
                    if (c.text === e.target.innerText) {
                      return c;
                    }
                  });
                  setData((prev) => {
                    return {
                      ...prev,
                      courses: {
                        ...prev.courses,
                        selected: {
                          text: id[0]?.text,
                          value: id[0]?.value,
                        },
                      },
                    };
                  });
                  setSelectedTutor("");
                  if (data.students.selected?.value) {
                    setFetchTeachers(true);
                  }
                  if (stepGuide == 4) {
                    setStepGuide((prev) => prev + 1);
                  }
                }}
              />
              <Overlay
                target={target2.current}
                show={showToolTipCourse}
                placement="right"
              >
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    Select Course
                  </Tooltip>
                )}
              </Overlay>
            </div>
            {selectedTutor !== "" && (
              <div
                className="col-7 d-flex"
                onClick={() => {
                  setSelectedTutor("");
                  setSelSessions([]);
                  setSessionBookedMessage("");
                  setSessionStatus({});
                  setDate(() => {
                    let current_datetime = new Date();
                    return (
                      current_datetime.getDate() +
                      "-" +
                      MONTHS[current_datetime.getMonth()] +
                      "-" +
                      current_datetime.getFullYear()
                    );
                  });
                  setData((prev) => {
                    return {
                      ...prev,
                      timeZone: {
                        ...prev.timeZone,
                        selected: [],
                      },
                    };
                  });
                }}
              >
                <p className="find-tutor-back-btn">Back To Results</p>
              </div>
            )}
          </div>

          {selectedTutor === "" ? (
            courseTutors?.length < 1 ? (
              <div className="empty-tutor-list-container">
                {tutorListEmpty ? (
                  <p>No Tutors Available for this course</p>
                ) : null}
                <img src={Frame} alt="" className="" />
              </div>
            ) : (
              courseTutors.map((tutor, i) => {
                return (
                  <div
                    className="row mt-4 find-tutor-card"
                    key={i}
                    onClick={() => {
                      console.log(tutor);
                      setSelectedTutor(tutor);
                      setBookTrialSessionModal(true);
                      if (
                        data.courses.selected?.value &&
                        data.students.selected?.value
                      ) {
                        setFetchSessionStatus(true);
                      }
                    }}
                  >
                    <div className="row px-0 find-tutor__tutor-card-header">
                      <div className="col-md-9 col-sm-12">
                        <div className="row px-0">
                          <div className="col-md-2 col-sm-12 tutor-profile-img">
                            <img
                              src={tutor?.image ? tutor.image : BlankAvatar}
                              alt=""
                            />
                          </div>
                          <div className="col-md-10 col-sm-12">
                            <div className="row mt-4 pt-2">
                              <div className="col-md-4 col-sm-12 tutor-card-title">
                                {tutor.teacherName}
                              </div>
                              <div className="col-md-6 col-sm-12">
                                Gender: {tutor.gender || "N/A"}
                              </div>
                              <div className="col-md-2 col-sm-12 tutor-card-fee">
                                {tutor.courseRate || "N/A"}
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-10">
                                {tutor?.about
                                  ? truncateString(tutor?.about)
                                  : "About: N/A"}
                              </div>
                              {/* <div className="col-2">
                      <button onClick={decoratedOnClick}>Expand</button>
                    </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-12 find-tutor__button-container">
                        <button>Book a Session</button>
                        <button>Chat</button>
                      </div>
                    </div>
                  </div>
                );
              })
            )
          ) : null}
          {selectedTutor !== "" && (
            <div className="row mt-4 find-tutor-card">
              <div className="row px-0 find-tutor__tutor-card-header">
                <div className="col-md-2 col-sm-12 tutor-profile-img">
                  <img
                    src={
                      selectedTutor?.image ? selectedTutor.image : BlankAvatar
                    }
                    alt=""
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <div className="row mt-4 pt-2">
                    <div className="col-md-4 col-sm-12 tutor-card-title">
                      {selectedTutor.teacherName}
                    </div>
                    <div className="col-md-6 col-sm-12">
                      Gender: {selectedTutor.gender || "N/A"}
                    </div>
                    <div className="col-md-2 col-sm-12 tutor-card-fee">
                      {selectedTutor.courseRate || "N/A"}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-10">
                      {selectedTutor?.about
                        ? truncateString(selectedTutor?.about)
                        : "About: N/A"}
                    </div>
                    {/* <div className="col-2">
                      <button onClick={decoratedOnClick}>Expand</button>
                    </div> */}
                  </div>
                </div>
                <div className="col-md-3 col-sm-12 find-tutor__button-container">
                  <button className="d-none">Book a Trial Session</button>
                  <button>Chat</button>
                </div>
              </div>
              <div className="row tutor-card-body">
                <div className="row mt-2 tutor-card-body-title">
                  <div className="col px-4">Schedule</div>
                </div>
                <div className="row mt-5 tutor-card-body-content">
                  <div className="col px-4">
                    Please select the preferred timing for your class.
                  </div>
                </div>
              </div>
              <div className="row px-4">
                <BookTrialSessionTable
                  date={date}
                  setDate={setDate}
                  data={data}
                  setData={setData}
                  slots={freeSlots.freeSlots}
                  setWeekCount={setWeekCount}
                  setFetchFreeSlots={setFetchFreeSlots}
                  selectedTutor={selectedTutor}
                  selSessions={selSessions}
                  setSelSessions={setSelSessions}
                  sessionStatus={sessionStatus}
                  timeZone={freeSlots.timeZoneName}
                  stepGuide={stepGuide}
                  setStepGuide={setStepGuide}
                />
              </div>
              {selSessions.length > 0 && (
                <div className="row px-4">
                  <div className="button-container">
                    <button
                      className="confirm"
                      onClick={() => {
                        handleSubmit();
                      }}
                      disabled={bookSession.demo || bookSession.paid}
                      ref={target3}
                    >
                      Confirm
                    </button>
                    <button
                      className="cancel"
                      onClick={() => setSelSessions([])}
                    >
                      Cancel
                    </button>
                    <Overlay
                      target={target3.current}
                      show={showToolTipConfirm}
                      placement="top"
                    >
                      {(props) => (
                        <Tooltip id="submit-button-overlay" {...props}>
                          Click on "Confirm" button to confirm the trial
                          sessions
                        </Tooltip>
                      )}
                    </Overlay>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/*Session Booked Display Modal */}
      <Modal
        show={sessionBookedModal}
        onHide={() => setSessionBookedModal(false)}
        dialogClassName="trial-session-booked-modal"
        centered
      >
        <Modal.Body>
          <div className="px-3 py-3 d-flex justify-content-between h-100 header">
            <div className="col-2 header">
              <img
                src={profileImage(selectedTutor.teacherName)}
                alt={"profile-image"}
              ></img>
            </div>
            <div className="col-10 header-title">
              <p>{sessionBookedMessage}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          onClick={() => {
            setSessionBookedModal(false);
            setSelectedTutor("");
            if (stepGuide == 7) {
              setStepGuide((prev) => prev + 1);
            }
          }}
        >
          <p>Okay, Got it.</p>
        </Modal.Footer>
      </Modal>
      {/*Trial Ended Modal */}
      <Modal
        show={trialEndedModal}
        onHide={() => setTrialEndedModal(false)}
        dialogClassName="trial-ended-modal"
        centered
      >
        <Modal.Body>
          <div className="px-3 py-3 d-flex justify-content-between h-100 header">
            <div className="col-2 header">
              <img
                src={profileImage(selectedTutor.teacherName)}
                alt={"profile-image"}
              ></img>
            </div>
            <div className="col-10 header-title">
              <p>{sessionStatus?.message}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              setTrialEndedModal(false);
            }}
          >
            {sessionStatus.returnFlag ? "Buy Additional Hours" : "Book Now"}
          </button>
        </Modal.Footer>
      </Modal>
      {/*Confirm Session Modal */}
      <Modal
        show={confirmSessionModal}
        onHide={() => setConfirmSessionModal(false)}
        dialogClassName="confirm-session-modal"
        centered
      >
        <Modal.Body>
          <div className="px-3 py-3 d-flex justify-content-between h-100 header">
            <div className="col-2 header">
              <img
                src={profileImage(selectedTutor.teacherName)}
                alt={"profile-image"}
              ></img>
            </div>
            <div className="col-10 header-title">
              <p>
                Hey,
                <br /> Please click the below link to confirm your recurring
                session for {data.courses.selected?.text} with me.
              </p>
            </div>
          </div>
          {selSessions?.map((s, i) => {
            return (
              <div className="body row p-2  " key={i}>
                <div className="col-2 d-flex align-items-center">
                  <p className="primary">{s.date.split("-")[0]}</p>
                  <p className="secondary">
                    &nbsp;{s.dayOfTheWeek.slice(0, 3)}
                  </p>
                </div>
                <div className="col-8 d-flex align-items-center">
                  <p className="mx-4">Hr</p>
                  <p className="time-input-disabled primary">
                    {s.startTime.split(":")[0]}
                  </p>
                  <p className="mx-4">Min</p>
                  <p className="time-input-disabled primary">
                    {s.startTime.split(":")[1]}
                  </p>
                </div>
                <div className="col-1 d-flex align-items-center mx-3 delete-button-container">
                  <button
                    onClick={() => {
                      let temp = [...selSessions];
                      temp = temp.filter((ses, i) => ses !== s);
                      setSelSessions(temp);
                      if (temp.length === 0) {
                        setConfirmSessionModal(false);
                      }
                    }}
                  >
                    Del
                  </button>
                </div>
              </div>
            );
          })}
          <div className="row confirm-button-container">
            <button
              onClick={() => {
                setBookSession((prev) => {
                  return { ...prev, paid: true };
                });
              }}
              disabled={bookSession.paid}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p
            onClick={() => {
              setConfirmSessionModal(false);
              setSelSessions([]);
            }}
          >
            Close
          </p>
        </Modal.Footer>
      </Modal>
      <FindTutorStepGuide stepGuide={stepGuide} setStepGuide={setStepGuide} />
      <Footer />
    </Layout>
  );
}

export default FindTutor;
